// extracted by mini-css-extract-plugin
export default {"container":"gba-z","oos":"hba-z","oosUx":"iba-z","selected":"jba-z","labelOos":"kba-z"};